module.exports = __webpack_public_path__ + "img/guncases_on.34da1e59.png";